<template>
  <qx-card-form title="其他">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span slot="isNeedBillTip" slot-scope="scope">
        <span class="error" v-if="scope.form.isNeedBill === '2'">
          （收票主体：{{
          defaultBillData && defaultBillData.billInfo
          ? defaultBillData.billInfo.billLookUp.length > 15
          ? defaultBillData.billInfo.billLookUp.substring(0, 15) + '..'
          : defaultBillData.billInfo.billLookUp
          : '未指定默认收票主体'
          }}）
        </span>
      </span>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import { checkDependTimeConflict } from 'api/operate';
export default {
  data () {
    return {
      parentComponent: null,
      defaultBillData: {},
      isNeedBillOptionsBackup: [],
      progressStep: 1,
      otherFormData: {
        otherData: {},
      },
      baseForm: {
        isNeedBillOptions: [],
        form: [
          {
            label: '票据要求',
            value: 'isNeedBill',
            type: 'radio',
            default: '0',
            onChange: (val) => {
              this.$emit('isNeedBillChange', val);
            },
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
        ],
      },
    };
  },
  methods: {
    getParentComponent (_this) {
      this.parentComponent = _this;
    },
    setList (options, otherData) {
      this.isNeedBillOptionsBackup = options;
      this.baseForm.isNeedBillOptions = options.filter((item) => item.value !== '1');
      this.defaultBillData = otherData.defaultBillData;
    },
    // 如果选择的调度模式选择的是指派车辆，则隐藏承运商开票这个选项
    optionsChange (isSelectVehicle) {
      if (isSelectVehicle) {
        this.baseForm.isNeedBillOptions = this.isNeedBillOptionsBackup.filter((item) => item.value !== '1');
      } else {
        this.baseForm.isNeedBillOptions = this.isNeedBillOptionsBackup;
      }
    },
    async isNeedBillChange (data) {
      let initIsNeedBillOption = '1';
      if (this.baseForm.isNeedBillOptions && this.baseForm.isNeedBillOptions.length) {
        initIsNeedBillOption = this.baseForm.isNeedBillOptions[0].value;
      }
      let isNeedBill = data.isNeedBill || initIsNeedBillOption;
      this.$refs.baseForm.setVal('isNeedBill', isNeedBill);
    },
    // 检查发车时间所需参数
    getCheckDependTimeParams (_baseForm, _modeForm) {
      let plateNumber = '';
      let carDriverId = '';
      let carDriverMan = '';
      let carDriverPhone = '';
      let copilotDriverId = '';
      let copilotMan = '';
      let copilotPhone = '';
      let vehicleClass = 0;
      let dependTime = _baseForm.$refs.baseForm.getVal('dependTime');
      dependTime = dependTime ? this.formatDate(dependTime, 1) : '';
      if (!dependTime) {
        this.$message({
          type: 'warning',
          message: '请选择发车时间',
        });
        return null;
      }
      const appointWay = _modeForm.$refs.baseForm.getVal('appointWay');
      if (appointWay === '3') {
        // 指派车辆的时候才需要检测车辆和司机信息
        const assignVehicle = _modeForm.$refs.assignVehicle;
        const chooseVehicle = assignVehicle.$refs.baseForm.getVal('chooseVehicle');
        plateNumber = chooseVehicle.plateNumber;
        vehicleClass = chooseVehicle.vehicleClass;
        if (!plateNumber) {
          this.$message({
            type: 'warning',
            message: '请选择车辆',
          });
          return null;
        }
        const driverInfo = assignVehicle.$refs.baseForm.getVal('chooseDriver');
        const copilotDriverInfo = assignVehicle.$refs.baseForm.getVal('chooseCopilotDriver') || {};
        carDriverId = driverInfo.userId;
        carDriverMan = driverInfo.linkman;
        carDriverPhone = driverInfo.loginAcct;
        copilotDriverId = copilotDriverInfo.userId || '';
        copilotMan = copilotDriverInfo.linkman || '';
        copilotPhone = copilotDriverInfo.loginAcct || '';
      }
      let params = {
        dependTime,
        plateNumber,
        carDriverId,
        carDriverMan,
        carDriverPhone,
        copilotDriverId,
        copilotMan,
        copilotPhone,
        vehicleClass,
      };
      if (this.$route.query.id) {
        params.orderId = this.$route.query.id;
      }
      return params;
    },
    async getDataTest () {
      // const res = await this.sub();
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData = {
          ...formData,
          ...this.otherFormData,
          progressStep: this.progressStep,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    getSubParams (formData) {
      // formData['dispatchInfo.remark'] = formData.remark;
      // delete formData['remark'];
      let otherParmas = {};
      if (formData) {
        otherParmas['dispatchInfo.remark'] = formData.remark;
        if (formData.otherData) {
          for (let name in formData.otherData) {
            if (name) {
              otherParmas['otherData.' + name] = formData.otherData[name];
            }
          }
        }
      }
      return otherParmas;
    },
    getPriceEnumAndUnitName (_this) {
      let priceEnumAndUnitName = '';
      let priceUnitName = '';
      const priceUnit = _this.$refs.baseForm.getVal('priceUnit');
      for (let item of _this.priceEnumOptions) {
        if (item.value === _this.otherFormData.priceEnum) {
          priceUnitName = item.label;
        }
      }
      priceEnumAndUnitName = `${priceUnit || ''}${priceUnitName}`;
      return priceEnumAndUnitName;
    },
    async showCostPrice () {
      const _incomeForm = this.parentComponent.$refs.incomeForm;
      const _modeForm = this.parentComponent.$refs.modeForm;

      const incomeFormData = await _incomeForm.sub();
      const modeFormData = await _modeForm.sub();
      // 预估收入
      const costPrice = incomeFormData['customerInfo.costPrice'] || '';
      // 单价
      const priceEnumAndUnitName = incomeFormData['customerInfo.priceEnumAndUnitName'];

      const vehicleClass = modeFormData['dispatchInfo.vehicleClass'];

      let preCashFee = 0;
      let oilAccount = 0;
      let oilCard = 0;
      let ectCard = 0;
      let insFee = 0;

      if (vehicleClass === 1) {
        // 现金/补贴
        preCashFee =
          ((modeFormData['dispatchInfo.preCashFee'] ? modeFormData['dispatchInfo.preCashFee'] - 0 : 0) - 0 +
            (modeFormData['dispatchInfo.arrivePaymentFee'] ? modeFormData['dispatchInfo.arrivePaymentFee'] - 0 : 0) - 0 +
            (modeFormData['dispatchInfo.finalCashFee'] && modeFormData['dispatchInfo.paymentWay'] === '3' ? modeFormData['dispatchInfo.finalCashFee'] - 0 : 0) - 0 +
            (modeFormData['dispatchInfo.subsidyTotal'] ? modeFormData['dispatchInfo.subsidyTotal'] - 0 : 0)).toFixed(2);
      } else {
        preCashFee = ((modeFormData['dispatchInfo.preCashFee'] ? modeFormData['dispatchInfo.preCashFee'] - 0 : 0) - 0 +
          (modeFormData['dispatchInfo.arrivePaymentFee'] ? modeFormData['dispatchInfo.arrivePaymentFee'] - 0 : 0) - 0 +
          (modeFormData['dispatchInfo.finalCashFee'] ? modeFormData['dispatchInfo.finalCashFee'] - 0 : 0) - 0).toFixed(2);
      }
      // 油账户
      const oilSelfVirtual = modeFormData['dispatchInfo.oilSelfVirtual'] ? modeFormData['dispatchInfo.oilSelfVirtual'] : 0;
      const preOilVirtualFee = modeFormData['dispatchInfo.preOilVirtualFee'] ? modeFormData['dispatchInfo.preOilVirtualFee'] : 0;
      oilAccount = modeFormData['dispatchInfo.paymentWay'] === '1' ? oilSelfVirtual : preOilVirtualFee;
      // 油卡
      const oilSelfEntity = modeFormData['dispatchInfo.oilSelfEntity'] ? modeFormData['dispatchInfo.oilSelfEntity'] : 0;
      const preOilFee = modeFormData['dispatchInfo.preOilFee'] ? modeFormData['dispatchInfo.preOilFee'] : 0;
      oilCard = modeFormData['dispatchInfo.paymentWay'] === '1' ? oilSelfEntity : preOilFee;
      // ETC
      const pontage = modeFormData['dispatchInfo.pontage'] ? modeFormData['dispatchInfo.pontage'] : 0;
      const preEtcFee = modeFormData['dispatchInfo.preEtcFee'] ? modeFormData['dispatchInfo.preEtcFee'] : 0;
      ectCard = modeFormData['dispatchInfo.paymentWay'] === '1' ? pontage : preEtcFee;
      // 保费
      insFee = modeFormData['dispatchInfo.insuranceFee'] ? modeFormData['dispatchInfo.insuranceFee'] : 0;

      console.log(`现金/补贴${preCashFee}`, `油账户：${oilAccount}`, `油卡：${oilCard}`, `ETC：${ectCard}`, `保费：${insFee}`);

      const h = this.$createElement;
      const resOrderInfo = await this.$confirm(h('div', null, [
        h('div', null, [
          h('p', null, '该订单的收入信息：'),
          h('p', null, `预估收入：${costPrice}元，单价：${priceEnumAndUnitName}`),
        ]),
        h('div', { style: 'margin-top: 16px;' }, [
          h('p', null, '该订单的成本信息：'),
          h('p', null, `现金/补贴：${preCashFee}元 ，油账户：${oilAccount}元 ，油卡：${oilCard}元 ，ETC：${ectCard}元 ，保费:${insFee}元`),
        ]),
      ]), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // ...
      });

      return resOrderInfo;
    },
    async sub () {
      let formData = await this.handleSubData();
      const _baseForm = this.parentComponent.$refs.baseForm;
      const _modeForm = this.parentComponent.$refs.modeForm;
      const params = this.getCheckDependTimeParams(_baseForm, _modeForm);
      let res = null;

      const resOrderInfo = await this.showCostPrice();
      if (resOrderInfo === 'confirm') {
        if (params) {
          const resCheck = await checkDependTimeConflict(params);
          // 检测副驾是否时间冲突
          const checkCopilotDriverConflict = async () => {
            if (resCheck.copilotDriverConflict === 'Y') {
              const confirmRes = await this.$confirm(`${params.copilotMan}（${params.copilotPhone}）在${params.dependTime}后已存在订单，确认该司机可承运本订单？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }).catch(() => {
                // ...
              });
              if (confirmRes === 'confirm') {
                // 不管检测结果，坚持保存订单
                return this.getSubParams(formData);
              }
            } else {
              // 检测通过，可提交参数-保存订单
              return this.getSubParams(formData);
            }
          };
          // 检测主驾是否时间冲突
          const checkDriverConflict = async () => {
            if (resCheck.driverConflict === 'Y') {
              const confirmRes = await this.$confirm(`${params.carDriverMan}（${params.carDriverPhone}）在${params.dependTime}后已存在订单，确认该司机可承运本订单？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }).catch(() => {
                // ....
              });
              if (confirmRes === 'confirm') {
                return checkCopilotDriverConflict();
              }
            } else {
              return checkCopilotDriverConflict();
            }
          };
          // 检测车辆是否时间冲突
          if (resCheck.plateNumberConflict === 'Y') {
            const confirmRes = await this.$confirm(`该车辆（${params.plateNumber}）在${params.dependTime}后已存在订单，确认该车辆可承运本订单？`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).catch(() => {
              // ...
            });
            if (confirmRes === 'confirm') {
              res = await checkDriverConflict();
            }
          } else {
            res = await checkDriverConflict();
          }
          // }
        }
      }
      return res;
    },
    setDetailData (data) {
      if (data.orderInfoExt) {
        this.otherFormData.otherData.preAmountFlag = data.orderInfoExt.preAmountFlag;
      }
      if (data.orderInfo) {
        this.otherFormData.otherData.opOrgId = data.orderInfo.opOrgId;
        this.otherFormData.otherData.isLockTheOrder = data.orderInfo ? data.orderInfo.isLockTheOrder : '';
      }
      if (data.orderGoods) {
        this.otherFormData.otherData.reciveState = data.orderGoods.reciveState;
        this.otherFormData.otherData.loadState = data.orderGoods.loadState;
      }
      if (data.orderFee) {
        this.otherFormData.otherData.finalFeeFlag = data.orderFee.finalFeeFlag;
        this.otherFormData.otherData.payoutStatus = data.orderFee.payoutStatus;
        this.otherFormData.otherData.verificationState = data.orderFee.verificationState;
        this.otherFormData.otherData.vehicleAffiliation = data.orderFee.vehicleAffiliation;
      }
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.setDetailData(data);
      if (!data.progressStep) {
        this.$emit('goFirstStep');
      }
      this.$refs.baseForm.setVal(data);
      this.isNeedBillChange(data);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
